export const ProductService = {
    getProductsData() {
        return [
            {              
                name: 'Analyze Document',
                description: 'Experience automated document analysis within the portal for all uploaded files.',
               
            },
            {
                name: 'Lorem Ipsum',
                description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            },
            {
                name: 'Lorem Ipsum',
                description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            },
            {
                name: 'Lorem Ipsum',
                description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            }
            
        ];
    },

   

    getProducts() {
        return Promise.resolve(this.getProductsData().slice(0, 5));
    },
    
};

